import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  avatar: {
    paddingRight: theme.spacing(1),
  },

  text: {
    textTransform: 'uppercase',
    fontFamily: '"Bebas Neue"',
    letterSpacing: '.05em',
    fontSize: theme.spacing(2),
    paddingRight: theme.spacing(0.5),
  },

  userName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: theme.spacing(15),
  },

  winningAmount: {
    color: theme.palette.success.light,
  },
}));
